import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
  Paper,
  Chip
} from '@mui/material';
import {
  Send as SendIcon,
  AttachFile as AttachFileIcon,
} from '@mui/icons-material';

const BrokerCommentDialog = ({ open, onClose, onSubmit, comment, files }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ 
        pb: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        color: '#1976d2'
      }}>
        <SendIcon />
        Submit Review
      </DialogTitle>

      <DialogContent sx={{ pb: 4 }}>
        {/* 文件上传总结 */}
        {files && files.length > 0 && (
          <Box sx={{ mb: 4 }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
              Attached Documents
            </Typography>
            {files.map((file, index) => (
              <Paper
                key={index}
                elevation={0}
                sx={{
                  p: 2,
                  mb: 1,
                  border: '1px solid #e0e0e0',
                  borderLeft: '4px solid #1976d2',
                  bgcolor: '#e3f2fd',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                    {file.name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {(file.size / 1024 / 1024).toFixed(2)} MB
                  </Typography>
                </Box>
                <Chip
                  icon={<AttachFileIcon />}
                  label="New Document"
                  size="small"
                  sx={{
                    bgcolor: 'white',
                    color: '#1976d2',
                    borderColor: '#1976d2',
                    '& .MuiChip-icon': { color: 'inherit' }
                  }}
                />
              </Paper>
            ))}
          </Box>
        )}

        <Divider sx={{ my: 3 }} />

        {/* Comment Content */}
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Comment Content
          </Typography>
          {comment ? (
            <Paper
              elevation={0}
              sx={{
                p: 2,
                border: '1px solid #e0e0e0',
                bgcolor: '#f8f9fa',
                borderLeft: '4px solid #1976d2'
              }}
            >
              <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.6 }}>
                {comment}
              </Typography>
            </Paper>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
              No additional comments provided
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, mt: 3 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{ 
            color: '#666',
            borderColor: '#666',
            '&:hover': {
              borderColor: '#666',
              bgcolor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          Edit
        </Button>
        <Button 
          onClick={onSubmit}
          variant="contained"
          color="primary"
          startIcon={<SendIcon />}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BrokerCommentDialog; 